/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Contact_Name_RequiredInputs */

const en_case_validation_contact_name_required = /** @type {(inputs: Case_Validation_Contact_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name is required.`)
};

const pt_br2_case_validation_contact_name_required = /** @type {(inputs: Case_Validation_Contact_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome é obrigatório.`)
};

/**
* | output |
* | --- |
* | "Name is required." |
*
* @param {Case_Validation_Contact_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_contact_name_required = /** @type {((inputs?: Case_Validation_Contact_Name_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Contact_Name_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_contact_name_required(inputs)
	return pt_br2_case_validation_contact_name_required(inputs)
});